module.exports = __webpack_public_path__ + "static/media/inOrOut (1).39628664.jpg";